import React from 'react';
import { Avatar, Icon } from 'antd';
import classNames from 'classnames';

export default function CatFilterItem({ category, isSelected, updateFilter, clearFilter }) {
  return (
    <li onClick={(updateFilter) ? updateFilter(category.id) : null}
        className={classNames('filter-item',
          { 'filter-item-active': isSelected })}
    >

      {
        (isSelected) ?
          <Icon type="close"
                className="p-absolute bordered circled"
                onClick={clearFilter(category.id)}
          /> : null
      }
      <Avatar size="small" src={category.logo} />
      <div>{category.name}</div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Categories/components/CatFilterList/CatFilterItem.js